/**
 * Müşteri ekipman beklentilerine veya seçilen ekipman türlerine göre araç uyumluluğu puanı hesaplar
 * @param {Object} order - Sipariş detayları
 * @param {Object} vehicle - Araç detayları
 * @param {Array} customers - Müşteri listesi
 * @param {Object} customerExpectedProducts - Müşteri beklenen ürünler objesi (customerID keyli)
 * @param {Object} vehicleInventories - Araç envanterleri objesi (vehicleID keyli)
 * @param {Array} requiredEquipmentCategories - Sipariş için gerekli ekipman kategorileri (opsiyonel)
 * @returns {Object} Ekipman uyumluluk skoru ve detayları
 */

const similarity = require("similarity");

function calculateEquipmentScore(
  order,
  vehicle,
  customers,
  customerExpectedProducts = {},
  vehicleInventories = {},
  requiredEquipmentCategories = null
) {
  try {
    // Null/undefined check for order and vehicle
    if (!order || !vehicle) {
      return {
        score: 1.0,
        formatted_score: '1.000',
        penalty: 0,
        missingRequired: [],
        missingOptional: [],
        insufficientRequired: [],
        message: 'Sipariş veya araç bilgisi eksik'
      };
    }

    // Araç envanterini al
    const vehicleInventory = vehicleInventories[vehicle.id] || [];

    // Araç envanterini hem ID hem de kategori bazında map'e dönüştür
    const vehicleCategoryMap = {};

    vehicleInventory.forEach(item => {
      if (!vehicleCategoryMap[item.category]) {
        vehicleCategoryMap[item.category] = [];
      }
      vehicleCategoryMap[item.category].push({
        inventory_id: item.inventory_id,
        name: item.name,
        quantity: item.quantity || 1,
        unit: item.unit || 'ADET'
      });
    });

    // Sadece "Ekipman ile Planla" seçildiğinde kontrol yap
    if (requiredEquipmentCategories && requiredEquipmentCategories.length > 0) {
      const missingRequired = [];
      const matchedRequired = [];

      requiredEquipmentCategories.forEach(category => {
        const categoryItems = vehicleCategoryMap[category] || [];

        if (categoryItems.length === 0) {
          missingRequired.push({
            category: category,
            required_quantity: 1,
            missingType: 'category'
          });
        } else {
          matchedRequired.push({
            category: category,
            available_quantity: categoryItems.length,
            categoryItems: categoryItems
          });
        }
      });

      // Skor hesaplama - seçilen ekipman türlerine göre
      let score = 1.0;
      let details = [];

      if (missingRequired.length > 0) {
        // Her eksik kategori için 0.3 puan düş
        score -= (missingRequired.length * 0.3);
        const missingCategories = missingRequired.map(p => p.category);
        details.push(`Eksik ekipman: ${missingCategories.join(', ')}`);
      }

      // Eşleşme oranına göre bonus puan
      const matchRatio = matchedRequired.length / requiredEquipmentCategories.length;
      if (matchRatio === 1.0) {
        details.push(`Tüm ekipmanlar mevcut (${matchedRequired.length}/${requiredEquipmentCategories.length})`);
      }

      score = Math.max(0, score);

      const isCompatible = missingRequired.length === 0;

      return {
        score: parseFloat(score.toFixed(3)),
        compatible: isCompatible,
        hasRequirements: true,
        isEquipmentBasedScore: true,
        matchedRequired: matchedRequired.map(p => ({
          category: p.category,
          available_quantity: p.available_quantity
        })),
        missingRequired: missingRequired.map(p => ({
          category: p.category
        })),
        totalRequired: requiredEquipmentCategories.length,
        matchRatio: matchRatio,
        details: details.length > 0 ? details.join(", ") : "Tüm ekipmanlar uyumlu"
      };
    }

    // Ekipman türü seçilmemişse, ekipman kontrolü yapma
    return {
      score: 1.0,
      compatible: true,
      hasRequirements: false,
      matchedRequired: [],
      missingRequired: [],
      insufficientRequired: [],
      missingOptional: [],
      insufficientOptional: [],
      details: "Ekipman kontrolü yapılmadı"
    };
  } catch (error) {
    console.error("Ekipman skoru hesaplanırken hata:", error);
    return {
      score: 1.0,
      compatible: true,
      hasRequirements: false,
      error: error.message,
      details: "Ekipman kontrolü yapılamadı"
    };
  }
}

module.exports = {
  calculateEquipmentScore
};